import styled from "@emotion/styled";
import { darken } from "polished";
var styles = {
    active: {
        alternative: {
            color: "natural0",
            underlineColor: "natural0",
            underlineHoverColor: "primary70"
        },
        muted: {
            color: "secondary100",
            underlineColor: "primary70",
            underlineHoverColor: "primary70"
        },
        primary: {
            color: "secondary100",
            underlineColor: "primary70",
            underlineHoverColor: "primary70"
        }
    },
    inactive: {
        alternative: {
            color: "natural0",
            underlineColor: "natural0",
            underlineHoverColor: "natural0"
        },
        muted: {
            color: "natural30",
            underlineColor: "natural30",
            underlineHoverColor: "natural30"
        },
        primary: {
            color: "natural30",
            underlineColor: "natural30",
            underlineHoverColor: "natural30"
        }
    }
};
var ButtonBase = /*#__PURE__*/ styled("button", {
    target: "e1sgs8xh0"
})("white-space:nowrap;padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";position:relative;cursor:pointer;border:0;background:transparent;&::after{background-color:", function(param) {
    var theme = param.theme, textStyle = param.textStyle;
    return theme.color[styles.active[textStyle].underlineColor];
}, ";border-top-left-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.xxs;
}, ";border-top-right-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.xxs;
}, ";content:'';transform:", function(param) {
    var theme = param.theme;
    return "translateY(".concat(theme.spacing[40], ")");
}, ";position:absolute;bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";left:0;height:", function(param) {
    var theme = param.theme;
    return theme.spacing[10];
}, ";width:100%;}");
var ActiveButton = /*#__PURE__*/ styled(ButtonBase, {
    target: "e1sgs8xh1"
})(ButtonBase, ";color:", function(param) {
    var textStyle = param.textStyle, theme = param.theme;
    return theme.color[styles.active[textStyle].color];
}, ";");
var InactiveButton = /*#__PURE__*/ styled(ButtonBase, {
    target: "e1sgs8xh2"
})(ButtonBase, ";color:", function(param) {
    var textStyle = param.textStyle, theme = param.theme;
    return theme.color[styles.inactive[textStyle].color];
}, ";&:hover{color:", function(param) {
    var textStyle = param.textStyle, theme = param.theme;
    return theme.color[styles.active[textStyle].color];
}, ";&::after{display:initial;background-color:", function(param) {
    var theme = param.theme, textStyle = param.textStyle;
    return darken(0.1, theme.color[styles.inactive[textStyle].underlineHoverColor]);
}, ";}}&::after{display:none;}");
export { ActiveButton, InactiveButton };
